<template>
  <div :class="computedClass">
    <input
      ref="radio-button"
      type="radio"
      :id="id ?? name"
      :name="name"
      :disabled="disabled"
      v-model="modelValue"
    />
    <label :for="id ?? name">
      <span :class="computedClassIndicator">
        <i class="jade-radio-button__marker"></i>
      </span>

      <div
        v-if="label"
        class="jade-radio-button__label"
      >
        <JadeText
          variant="text-medium"
          weight="regular"
          color="current-color"
        >
          {{ label }}
        </JadeText>
      </div>
      <div
        v-if="supportText"
        class="jade-radio-button__support"
      >
        <JadeText
          variant="text-small"
          weight="regular"
          color="current-color"
        >
          {{ supportText }}
        </JadeText>
      </div>
    </label>
  </div>
</template>

<script>
import JadeText from '../JadeText'
export default {
  name: 'JadeRadioButton',
  components: {
    JadeText
  },
  props: {
    value: String,
    label: String,
    supportText: String,
    name: String,
    id: String,
    disabled: Boolean,
    disabledFocus: Boolean
  },
  computed: {
    computedClass () {
      return {
        'jade-radio-button': true,
        'is-unlabeled': !this.label && !this.supportText
      }
    },
    computedClassIndicator () {
      return {
        'jade-radio-button__indicator': true,
        'is-focus-disabled': this.disabledFocus
      }
    },
    modelValue: {
      get () {
        return this.value
      },
      set () {
        this.$emit('onChange', this.value)
        this.$emit('update:value', this.value)
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/radio-button.css';
</style>
